module.exports = __webpack_public_path__ + "img/ben-about-hero.040cd84a.svg";